import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  rating: number;
  views: number;
  status: string;
  updatedAt?: string;
  latestChapter?: string;
}

export default function ComicCard({
  id,
  title,
  author,
  cover,
  category,
  rating,
  views,
  status,
  updatedAt,
  latestChapter,
}: ComicCardProps) {
  const categoryNames: Record<string, string> = {
    romance: '恋爱',
    fantasy: '奇幻',
    action: '动作',
    mystery: '悬疑',
    bl: 'BL',
    school: '校园',
    comedy: '搞笑',
    historical: '古风',
  };

  const formatViews = (v: number) => {
    if (v >= 1000000) return `${(v / 1000000).toFixed(1)}M`;
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link to={`/comic/${id}`} className="group block">
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <p className="text-background-50 text-xs leading-relaxed line-clamp-3">
            {title}
          </p>
        </div>
        {status === '已完结' && (
          <div className="absolute top-2 left-2 bg-foreground-950/70 text-background-50 text-xs px-2 py-0.5 rounded-md">
            已完结
          </div>
        )}
        <div className="absolute top-2 right-2 bg-primary-500 text-background-50 text-xs font-bold px-2 py-0.5 rounded-md flex items-center gap-1">
          <i className="ri-star-fill text-[10px]"></i>
          {rating}
        </div>
      </div>

      <h4 className="text-sm font-semibold text-foreground-950 line-clamp-1 mb-1 group-hover:text-primary-500 transition-colors">
        {title}
      </h4>

      <div className="flex items-center gap-2 text-xs text-foreground-500">
        <span className="bg-secondary-100 text-secondary-700 px-1.5 py-0.5 rounded text-[11px]">
          {categoryNames[category] || category}
        </span>
        <span>{author}</span>
      </div>

      <div className="flex items-center justify-between mt-1.5 text-xs text-foreground-400">
        <span className="flex items-center gap-1">
          <i className="ri-eye-line"></i>
          {formatViews(views)}
        </span>
        {latestChapter && (
          <span className="text-primary-500 truncate max-w-[100px]">{latestChapter}</span>
        )}
      </div>
    </Link>
  );
}